/**
 * Single source of truth for an offering's display title.
 *
 * An offering may override its programme's title (`titleOverride`). When set, the OVERRIDE WINS —
 * it is the more specific, deliberately-chosen label for that offering. The programme title is the
 * fallback, and a "Programma #<id>" placeholder is the last resort when neither is known.
 *
 * (Several call sites historically had the precedence reversed — `programmeTitle ?? titleOverride` —
 * which let a generic programme title mask a specific offering override. Use this helper instead.)
 */
export function offeringTitle(
  titleOverride: string | null | undefined,
  programmeTitle: string | null | undefined,
  offeringId?: number | null,
): string {
  return (
    titleOverride ||
    programmeTitle ||
    (offeringId != null ? `Programma #${offeringId}` : "Programma")
  );
}
